import { computed } from 'vue';
import { useRoute } from '@core/composables/use-router';

// Pages that render with a minimal, distraction-free header (no main nav, full header pills,
// etc). Add a route name here to enclose a new page.
const ENCLOSED_ROUTE_NAMES = new Set(['checkout', 'payment', 'carts']);

// Pages where the search bar specifically stays hidden. Narrower than ENCLOSED_ROUTE_NAMES —
// e.g. the cart page hides the main nav but keeps search available, unlike checkout/payment.
const SEARCH_HIDDEN_ROUTE_NAMES = new Set(['checkout', 'payment']);

const useEnclosedPage = () => {
  const route = useRoute();
  const routeName = computed(() => route.value?.name);
  const isEnclosedPage = computed(() => ENCLOSED_ROUTE_NAMES.has(routeName.value as string));
  const isSearchHiddenPage = computed(() => SEARCH_HIDDEN_ROUTE_NAMES.has(routeName.value as string));

  return {
    isEnclosedPage,
    isSearchHiddenPage,
  };
};

export default useEnclosedPage;
